import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import { TRFPUsersRequest } from '../types'
import { ResponseWithPagination } from '../../../../constants'
import { TContractCategoriesUsersList } from '../../../ContractCategoryDetails/Users/types'

const fetcher = new Fetcher({})

export const getAvailableUsers = async ({ id, data }) =>
  fetcher.request<
    TRFPUsersRequest,
    ResponseWithPagination<TContractCategoriesUsersList>
  >({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.FACILITY_USERS}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.USER}`,
    method: HTTP_METHODS.GET,
    ...data
  })
